import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Component({
  selector: 'gen-report-summary-text',
  templateUrl: './report-summary-text.component.html',
  styleUrls: ['./report-summary-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ReportSummaryTextComponent implements OnInit {

  public payload: {
      summaryText: string
  };
  public tunnel$: Subject<any>;
  public callback: (summaryText: string) => void;
  public summaryText: string = '';

  constructor() { }

  ngOnInit() {

    this.summaryText = this.payload.summaryText;

    this.tunnel$
      .asObservable()
      .filter(message => message.emitter != 'children' && message.value)
      .map(message => message.value)
      .subscribe((data) => {
        this.callback(this.summaryText);
        this.tunnel$.next({ emitter: 'children', value: 1});
      });
  }

  updateSummaryText(text: string) {
    this.summaryText = text;
  }
}
